import "./IndustriesExperience.module.css";
import Header from "@/reusable_sections/Header";
import IndustriesOverview from "./sections/IndustriesOverview";
import ExperienceHighlights from "./sections/ExperienceHighlights";
import ContactInquiry from "./sections/ContactInquiry";
import Footer from "@/reusable_sections/Footer";
export default function IndustriesExperiencePage() {
  return <div>
      <Header />
      <IndustriesOverview />
      <ExperienceHighlights />
      <ContactInquiry />
      <Footer />
    </div>;
}